import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(rootSaga);

import { all, fork } from 'redux-saga/effects';
import authSaga from './auth/auth.sagas';
import formsSaga from './forms/forms.sagas';
import gridsSaga from './grids/grids.sagas';
import loaderSaga from './loader/loader.saga';
import modalSaga from './modals/modals.sagas';
import popupSaga from './popups/popups.sagas';
import snackbarsSaga from './snackbars/snackbars.sagas';
import socketSaga from './socket/socket.sagas';
export function rootSaga() {
  return _regeneratorRuntime.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([fork(formsSaga), fork(modalSaga), fork(authSaga), fork(loaderSaga), fork(gridsSaga), fork(popupSaga), fork(snackbarsSaga), fork(socketSaga)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}